<template>
    <div>
        <div class="container-fluid">
            <!-- Head -->
            <div class="d-flex align-items-center justify-content-between pt-4 mb-4">
                <div class="d-block">
                    <div class="d-block mb-1">Atur Rasionalisasi</div>
                    <div class="h1-lg display-tektur m-0">Saran</div>
                </div>
            </div>

            <form v-on:submit.prevent="onSubmit" v-if="!dataFetch">
                <div class="d-block">
                    <div class="d-block mb-4 font-bold border-bottom pb-3">Saran sesuai Rumpun, Provinsi, Kampus</div>
                    <div class="row mb-3">
                        <div class="col-2"></div>
                        <div class="col-2 text-sm font-bold text-pink">Pilihan 1</div>
                        <div class="col-2 text-sm font-bold text-pink">Pilihan 2</div>
                    </div>
                    <div class="row align-items-center mb-3">
                        <div class="col-2">
                            Jurusan
                        </div>
                        <div class="col-2">
                            <div class="form-group form-style-1 m-0">
                                <input type="text" class="form-control" v-model="form.major_one" required oninvalid="this.setCustomValidity('Masukan Jurusan Pilihan satu')" oninput="this.setCustomValidity('')">
                            </div>
                        </div>
                        <div class="col-2">
                            <div class="form-group form-style-1 m-0">
                                <input type="text" class="form-control" v-model="form.major_two" required oninvalid="this.setCustomValidity('Masukan Jurusan Pilihan dua')" oninput="this.setCustomValidity('')">
                            </div>
                        </div>
                    </div>
                    <div class="row align-items-center mb-3">
                        <div class="col-2">
                            Rumpun
                        </div>
                        <div class="col-2">
                            <div class="form-group form-style-1 m-0">
                                <input type="text" class="form-control" v-model="form.group_one" required oninvalid="this.setCustomValidity('Masukan Rumpun Pilihan satu')" oninput="this.setCustomValidity('')">
                            </div>
                        </div>
                        <div class="col-2">
                            <div class="form-group form-style-1 m-0">
                                <input type="text" class="form-control" v-model="form.group_two" required oninvalid="this.setCustomValidity('Masukan Rumpun Pilihan dua')" oninput="this.setCustomValidity('')">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex align-items-center justify-content-between border-top pt-4">
                    <div class="d-flex align-items-right">
                        <button type="submit" class="btn btn-primary btn-s-1" :disabled="waiting">
                            <div class="btn-s-1-inner">{{ waiting ? 'Harap tunggu ...' : 'Simpan Data' }}</div>
                        </button>
                    </div>
                </div>
            </form>            
        </div>
        
        <div v-if="dataFetch" class="container-fluid mt-4">
            <div class="card">
                <div class="card-body">
                    <div class="d-block text-center py-4">
                        <div class="d-block mb-2 text-muted"><i class="fa-solid fa-spin fa-spinner fa-lg"></i></div>
                        <div class="d-block text-sm text-muted ">Loading...</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";
export default {
    name: 'SuggestionMain',
    metaInfo: {
        title: 'Saran',
        titleTemplate: '%s - Rasionalisasi Rapor'
    },
    data() {
        return {
            emptyState  : false,
            dataFetch   : false,
            dataList    : [],
            form : {
                id          : "",
                major_one   : "",
                major_two   : "",
                group_one   : "",
                group_two   : ""
            },
            submitted       : false,
            waiting         : false
        }
    },
    validations: {
        form: {
            major_one: {
                required
            },
            major_two: {
                required
            },
            group_one: {
                required
            },
            group_two: {
                required
            }
        }
    },
    created() {
        this.getData();
    },
    methods: {
        getData: function() {
            let uri         = process.env.VUE_APP_APIHOST+'suggestion/check';

            this.dataFetch  = true;                
            this.$http.get(uri).then(res => {
                this.dataFetch  = false;                
                this.form       = res.data.data;
            });
        },
        onSubmit: function () {
            this.waiting    = true;
            this.submitted  = true;

            // stop here if form is invalid
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.$swal({
                    icon: 'warning',
                    title: 'Ups!',
                    text: 'Harap lengkapi form',
                });

                this.waiting = false;
                return;
            } else {    
                let formData = new FormData();
                for (let key in this.form) {
                    formData.append(key, this.form[key]);
                }

                this.$http.post(process.env.VUE_APP_APIHOST + 'suggestion/save', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                        if (response.data.status) {
                            this.$swal({
                                icon: 'success',
                                title: 'Success',
                                text: response.data.message,
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                if (result.value) {
                                    this.getData();
                                }
                            });
                        } else {
                            this.$swal({
                                icon: 'warning',
                                title: 'Ups!',
                                text: response.data.message,
                            });
                        }
                        this.waiting = false;
                    })
                .catch(function () {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: 'Please check your internet connection.',
                    });
                    this.waiting = false;
                    return;
                });
            }
        }
    }
}
</script>
